<template>
  <div class="">
      <template v-if="!showSendEstimateModal">
      <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
        <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica">
          <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
            AWESOME!
          </h2>

          <p>
            You have completed {{ completedPaths }} tutorial. Now you can either send your 
            estimate or quote to a client or start the {{ unCompletedPaths }} tutorial. 
            Please make a selection.
          </p>
          <div>
            <div class="tw-mt-8 tw-grid tw-grid-cols-2 tw-gap-10 sm:tw-flex tw-text-secondary tw-text-sm">
              <div @click="selectPath(path)" :key="path.id" v-for="path in paths" class="sm:tw-w-1/3 tw-flex tw-flex-col tw-justify-center tw-items-center tw-cursor-pointer">
                <div class="tw-relative">
                  <svg-icon v-if="path.complete" name="solid/check-circle" class="tw-z-10 tw--translate-y-1/2 tw-absolute tw-h-6 tw-right-0 tw-transform tw-translate-x-1/2 tw-text-secondary"/>
                  <img class="tw-h-40 tw-w-auto" :src="path.image" :class="{'tw-filter tw-grayscale': path.complete}"/>
                </div>
                <p class="tw-text-center" :class="{'tw-filter tw-grayscale': path.complete}">{{ path.title }}</p>
                <p class="tw-text-primary tw-text-center" :class="{'tw-filter tw-grayscale': path.complete}">
                  {{ path.complete? '(Completed)': path.subtitle }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <template v-slot:footer>
          <div class="tw-mt-4 tw-flex tw-space-x-4">
            <button @click="sendEstimate" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
              <svg-icon name="solid/clipboard-list"/> <span class="tw-ml-2">SEND ESTIMATE</span>
            </button>

            <button @click="sendQuote" class="btn btn_transparent tw-m-0 tw-flex tw-items-center">
              <svg-icon name="solid/tape"/> <span class="tw-ml-2">SEND QUOTE</span>
            </button>
          </div>
        </template>
      </Modal>
      </template>

      <!-- <transition name="fade" v-if="showSendEstimateModal"> -->
      <send-estimate v-if="showSendEstimateModal" @onClose="showSendEstimateModal = false" :type="type"/>
      <!-- </transition> -->
  </div>

</template>

<script>
import Modal from '@/components/modals/Generic'
import SendEstimate from './../SendEstimate'

export default {
    name: 'DemoWizard',
    components: {
        Modal, SendEstimate
    },
    data() {
      return {
        showSendEstimateModal: false,
        type: '',
      }
    },
    computed: {
      completedPaths() {
        return this.paths.filter(x => x.complete).map(i => i.name).join(',')
      },
      unCompletedPaths() {
        return this.paths.filter(x => !x.complete).map(i => i.name).join(' or ') 
      },
      paths() {
        return this.$store.state['demoWizard'].paths
      }
    },
    methods: {
      sendEstimate() {
        this.type = 'estimate'
        this.showSendEstimateModal = true
      },
      sendQuote() {
        this.type = 'quote'
        this.showSendEstimateModal = true
      },
      selectPath(path) {
        this.$store.commit('demoWizard/setPath', path)
        this.$store.commit('demoWizard/goToStep', 4)
      }
    }
}
</script>

<style lang="scss">

</style>
